<script lang="ts" setup>
import { NConfigProvider } from 'naive-ui'
import { zhCN, dateZhCN } from 'naive-ui'
import { theme } from '~~/theme'

const props = defineProps<{
  error: {
    url: string
    statusCode: number
    statusMessage: string
    message: string
    stack: string
  }
}>()
useHead({
  title: props.error.message
})

const maxWidth = '1000px'
</script>

<template>
  <div class="m-layout">
    <n-config-provider
      :locale="zhCN"
      :date-locale="dateZhCN"
      :theme-overrides="theme"
      inline-theme-disabled
      abstract
    >
      <n-dialog-provider to="body">
        <n-message-provider to="body">
          <TopBar />
          <MContainer class="paper" padding>
            <n-result status="error" :title="error.message">
              <template v-if="error.statusCode === 404" #icon>
                <NuxtImg
                  src="https://resource.mfuns.net/imgs/404.png"
                  alt="404-image"
                  class="icon-img"
                />
              </template>
              <div v-html="error.stack"></div>
              {{ error }}
              <template #footer>
                <m-link to="/" title="回到首页" link self>回到首页</m-link>
              </template>
            </n-result>
          </MContainer>
        </n-message-provider>
      </n-dialog-provider>
    </n-config-provider>
  </div>
</template>

<style lang="scss" scoped>
.icon-img {
  width: 200px;
}
.m-layout {
  padding-top: 72px;
  min-height: calc(100vh - 500px);
  &-page {
    max-width: v-bind(maxWidth);
    position: relative;
    margin: 0 auto;
  }
}

@media screen and (max-width: 800px) {
  .m-layout {
    &-page {
      min-width: max(50vw, 800px);
    }
  }
}

@media screen and (max-width: 600px) {
  .m-layout {
    &-page {
      width: 100%;
      min-width: 0px;
    }
  }
}
</style>
